import { Box } from "@mui/material";
import React from "react";
export const ResponsiveLineBreak = (props) => (React.createElement(Box, { component: "span", sx: {
        display: Object.keys(props).reduce((acc, el) => ({ ...acc, [el]: props[el] ? "inline" : "none" }), { xs: "none", sm: "none", md: "none", lg: "none", xl: "none" }),
    } },
    React.createElement("br", null)));
//# sourceMappingURL=responsive-line-break.js.map